import { cn } from '~/shadcn/lib/utils'
import type { ProjectCollateralSubcategory } from '~/@pages_investing/projects/_project_types/projectCollateralSubCategory'
import { SkFlagIcon } from '~/@mid_ui/icons/SkFlagIcon'
import type { ProjectCollateralCategory } from '~/@pages_investing/projects/_project_types/projectCollateralCategory'
import { bgColorClassNamesByCollateralCategory } from '../project-collateral/bgColorClassNamesByCollateralCategory'
import { getProjectCollateralSubcategoryLabel } from '../project-collateral/labelByCollateralSubcategory'

type Props = {
  category: ProjectCollateralCategory
  subcategory: ProjectCollateralSubcategory
  location?: string | null
}

export function ProjectLabel({ category, subcategory, location }: Props) {
  return (
    <div className="flex h-full flex-col content-center justify-center">
      <ProjectCollatedalLabelTag
        category={category}
        subcategory={subcategory}
      />
      <ProjectLocationLocation location={location ?? null} />
    </div>
  )
}

function ProjectCollatedalLabelTag(props: {
  category: ProjectCollateralCategory
  subcategory: ProjectCollateralSubcategory
}) {
  return (
    <div
      className={cn(
        `flex h-[20px] max-w-fit items-center gap-[10px] rounded-tl-[12px] rounded-tr-[4px] rounded-br-[4px] rounded-bl-[12px] pr-[6px]`,
        bgColorClassNamesByCollateralCategory[props.category] ?? 'bg-[#7A5200]'
      )}>
      <SkFlagIcon width={20} height={20} />
      <span className="whitespace-nowrap text-[11px] uppercase leading-normal text-[#FFF8EB]">
        {getProjectCollateralSubcategoryLabel(props.subcategory)}
      </span>
    </div>
  )
}

function ProjectLocationLocation(props: { location: string | null }) {
  if (props.location == null) return null
  return <p className="text-sm font-semibold text-muted">{props.location}</p>
}
